import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ROUTE_PATHS } from "@/constants/navigation";

export type NavigationRouteState = {
  pathname: string;
};

const initialState: NavigationRouteState = {
  pathname: typeof window !== "undefined" ? window.location.pathname : "/",
};

const navigationRouteSlice = createSlice({
  name: "navigationRoute",
  initialState,
  reducers: {
    navigationPathnameSync: (state, action: PayloadAction<string>) => {
      state.pathname = action.payload;
    },
  },
});

export const { navigationPathnameSync } = navigationRouteSlice.actions;

export default navigationRouteSlice.reducer;

const sparxsEditorPrefix = ROUTE_PATHS.SPARXS_EDITOR.toLowerCase();

/** Matches `/sparxseditor` and `/sparxseditor/...` (deep links). */
export const selectIsSparxsEditorRoute = (state: {
  navigationRoute: NavigationRouteState;
}): boolean => {
  const p = state.navigationRoute.pathname.trim().toLowerCase();
  return p === sparxsEditorPrefix || p.startsWith(`${sparxsEditorPrefix}/`);
};
